import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_TESTIMONIALS,
  GET_TESTIMONIAL_DETAILS,
  CREATE_TESTIMONIAL,
  UPDATE_TESTIMONIAL,
  DELETE_TESTIMONIAL,
} from "./actionTypes"
import {
  getTestimonialsFail,
  getTestimonialsSuccess,
  getTestimonialDetailsSuccess,
  getTestimonialDetailsFail,
  createTestimonialFail,
  createTestimonialSuccess,
  updateTestimonialSuccess,
  updateTestimonialFail,
  deleteTestimonialSuccess,
  deleteTestimonialFail,
} from "./actions"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"

// Testimonial - This line cannot be edited or removed
function getTestimonialsAPi({ page, sort, limit, searchText }) {
  return get(
    `/testimonial/admin/all/?page=${page ? page : 1}&limit=${
      limit ? limit : 10
    }&search=${searchText}`
  )
}

const getTestimonialDetailsAPi = testimonialId => {
  return get(`/testimonial/admin/${testimonialId}`)
}

const createTestimonialApi = ({ testimonial, onCloseClick }) => {
  return post("/testimonial/admin/new", testimonial, onCloseClick)
}

const updateTestimonialApi = ({ testimonial, testimonialId, onCloseClick }) => {
  return ApiPut(
    `/testimonial/admin/${testimonialId}`,
    testimonial,
    onCloseClick
  )
}

const deleteTestimonialApi = ({ testimonialId }) => {
  return del(`/testimonial/admin/${testimonialId}`)
}

function* fetchTestimonials({ payload }) {

  try {
    const response = yield call(getTestimonialsAPi, payload)
    yield put(getTestimonialsSuccess(response))
  } catch (error) {
    yield put(getTestimonialsFail(error))
  }
}

function* fetchTestimonialDetails({ payload: testimonialId }) {
  try {
    const response = yield call(getTestimonialDetailsAPi, testimonialId)
    yield put(getTestimonialDetailsSuccess(response))
  } catch (error) {
    yield put(getTestimonialDetailsFail(error))
  }
}

function* onCreateTestimonial({ payload }) {
  try {
    const response = yield call(createTestimonialApi, payload)

    yield put(createTestimonialSuccess(response))
    if (payload?.onCloseClick) {
      payload.onCloseClick()
    }
    doneNotification("Testimonial Created Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createTestimonialFail(error))
  }
}

export function* onUpdateTestimonial({ payload }) {
  try {
    const response = yield call(updateTestimonialApi, payload)

    if (response) {
      yield put(updateTestimonialSuccess(response))

      Notification({
        type: "success",
        message: "Testimonial Updated Successfully!",
        title: "",
      })

      // Call the modal close callback
      if (payload?.onCloseClick) {
        payload.onCloseClick()
      }
    }
  } catch (error) {
    console.error("Update Testimonial Error:", error)

    const message =
      error?.response?.data?.message || error?.message || "Something went wrong"

    Notification({
      type: "error",
      message,
      title: "",
    })

    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "File size is too large",
        title: "",
      })
    }

    yield put(updateTestimonialFail(error?.response?.data || { message }))
  }
}
function* onDeleteTestimonial({ payload }) {
  try {
    const response = yield call(deleteTestimonialApi, payload)
    yield put(deleteTestimonialSuccess(response))
    doneNotification("Testimonial Deleted Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteTestimonialFail(error?.response?.data))
  }
}

function* testimonialSaga() {
  yield takeEvery(GET_TESTIMONIALS, fetchTestimonials)
  yield takeEvery(GET_TESTIMONIAL_DETAILS, fetchTestimonialDetails)
  yield takeEvery(CREATE_TESTIMONIAL, onCreateTestimonial)
  yield takeEvery(UPDATE_TESTIMONIAL, onUpdateTestimonial)
  yield takeEvery(DELETE_TESTIMONIAL, onDeleteTestimonial)
}

export default testimonialSaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
